import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {PartnerState} from "@/interfaces/state/partner";
import {Partner} from "@/interfaces/entity/partner";
import {
    createPartner, deletePartner,
    listPartner,
    singlePartner,
    updatePartner
} from "@/modules/partners/services";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {PartnerParams} from "@/modules/partners/params";
import { union } from 'lodash';

@Module({ dynamic: true, name: "partner", store })
class PartnerModule extends VuexModule implements PartnerState {
    data: IdMapper<Partner> = {};
    ids: string[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: PartnerParams = new PartnerParams();

    type = {};

    @Mutation
    private UPDATE_PARTNER_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private MAP_PARTNER({payload, refresh = false}) {
        if (refresh) {
            this.data = {} as any;
            this.ids = [] as any;
            this.type = {} as any;
        }
        this.meta = payload.meta;
        payload.datas?.forEach((partner: Partner, index: number) => {
            this.data[partner.rowGuid!] = {...partner, isDeleting: false, stt: index + 1} as any;
            this.ids = union(this.ids, [partner.rowGuid]);
            if (!this.type[partner.type]) {
                this.type[partner.type] = []
            }
            this.type[partner.type] = union(this.type[partner.type], [partner.rowGuid]);
        });
    }

    @Mutation
    private SET_PARTNER(payload: Partner) {
        this.ids = union(this.ids, [payload.rowGuid]);
        this.data[payload.rowGuid] = { ...this.data[payload.rowGuid] || {}, ...{...payload, isDeleting: false} }
    }

    @Mutation
    private DELETE_PARTNER(payload: Partner) {
        this.ids = this.ids.filter((rowGuid: string) => rowGuid !== payload.rowGuid);
        delete this.data[payload.rowGuid];
    }

    @Mutation
    private START_DELETE_PARTNER(rowGuid: string) {
        this.data[rowGuid].isDeleting = true;
    }

    @Mutation
    private END_DELETE_PARTNER(rowGuid: string) {
        this.data[rowGuid].isDeleting = false;
    }

    @Action({ rawError: true })
    public setPartner(payload: Partner) {
        this.SET_PARTNER(payload);
    }

    @Action({ rawError: true })
    public async createPartner(form: any) {
        const { data } = await createPartner(form);
        this.SET_PARTNER(data.data);
    }

    @Action({ rawError: true })
    public async listPartner({ params, refresh = false }) {
        const { data } = await listPartner(params);
        this.MAP_PARTNER({ payload: data, refresh });
        return data.datas;
    }

    @Action({ rawError: true })
    public async singlePartner(rowGuid: string) {
        const { data } = await singlePartner(rowGuid);
        return data.data;
    }

    @Action({ rawError: true })
    public async updatePartner(dataReq: any) {
        const { data } = await updatePartner(dataReq.rowGuid, dataReq);
        this.SET_PARTNER(data.data);
    }

    @Action({ rawError: true })
    public async deletePartner(rowGuid: string) {
        this.START_DELETE_PARTNER(rowGuid);
        const { data } = await deletePartner(rowGuid);
        this.END_DELETE_PARTNER(rowGuid);
        this.DELETE_PARTNER(data.data);
    }

    @Action({ rawError: true })
    public updatePartnerParams(payload: any) {
        this.UPDATE_PARTNER_PARAMS(payload);
    }
}

export const PartnerStore = getModule(PartnerModule);
